import React, { useRef, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { classNames } from 'primereact/utils'
import { Password } from "primereact/password"
import { InputText } from 'primereact/inputtext'
import { Link } from 'react-router-dom'
import server from 'infra/server'
import { Message } from 'primereact/message'

export default function Register() {

    const [message, setMessage] = useState('')
    const [messageSeverity, setMessageSeverity] = useState('')
    const toast = useRef(null)
    const txtSearch = window.location.search // Ex: ?loginUsu=bia@gmail.com&regcodUsu=103129

    const data = {}
    const params = new URLSearchParams(txtSearch)
    params.forEach((value, key) => data[key] = value)

    const defaultValues = {
        email: data.loginUsu,
        regcodUsu: data.regcodUsu,
        ...data
    }

    const form = useForm({ defaultValues })

    const errors = form.formState.errors

    const [loading, setLoading] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768 || window.innerHeight < 420)

    const toastIf = (expression, detail) => {
        if (expression) {
            toast.current.show({ severity: 'error', summary: 'Ops!', detail })
            return true
        }
        return false
    }

    const onSubmit = (data) => {
        setMessageSeverity('')
        setMessage('')

        if (toastIf(data.password.length < 5, 'Senha muito curta')) {
        } else if (toastIf(data.password !== data.password_repeat, 'As senhas devem ser iguais')) {
        } else {
            toast.current.show({ severity: 'info', summary: 'Criação de senha', detail: 'Criando...' })
            const postData = {
                "loginUsu": data.email,
                "regcodUsu": data.regcodUsu,
                "password": data.password
            }
            server().post('/registertentantusertoadminconfirm', postData).then((response) => {

                toast.current.clear()

                setMessageSeverity('info')
                setMessage(response.data)
                toast.current.show({ severity: 'info', summary: 'Criação de senha', detail: response.data })

            }).catch((err) => {

                toast.current.clear()
                const detail = err?.response?.data?.message || err.message
                setMessageSeverity('error')
                setMessage(detail)

            })

        }
    }

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error">{errors[name].message}</small> : <small className="p-error">&nbsp;</small>
    }

    return (
        <div className="flex flex-column md:flex-row bg-white h-screen">

            {/* Esquerda: Branding */}
            {isMobile ? (
                <></>
            ) : (
                < div className="md:w-6 border-0" >
                    <img src="/login-sup-esq.svg" className='border-0' alt="Arte superior esquerda" />
                    <div className='flex border-0 absolute' style={{ top: '50%', left: '25%' }}>
                        <img src="/logo.svg" className='' alt="Logo" style={{ width: '15%' }} />
                        <div>
                            <div className='text-7xl ml-4'>Fiz Aqui</div>
                            <div className='ml-5 mt-1 text-gray-400'>Enterprise Resource Planning</div>
                        </div>
                    </div>
                </div>
            )}

            {/* Direita: Formulário */}
            <div className={`border-0 w-full md:w-${isMobile ? 12 : 6} flex flex-column align-items-center`}>

                {/* Cabeçalho */}
                <div className="border-0 pb-8 border-green-500 p-0 w-full flex flex-column align-items-end relative">

                    <img className="absolute" src="/login-sup-dir.svg" alt="Arte superior direira" />
                    <div className="absolute flex flex-nowrap mt-2 mr-4 ext-white text-lg">
                        <Link id='redefinePassword' to="/redefinirsenha" className="text-white no-underline">Esqueci minha senha</Link>
                        <div className='mx-2 text-white'>|</div>
                        <Link id='addExtraBase' to="/adicionabaseextra" className="text-white no-underline">Adicionar base</Link>
                    </div>

                </div>

                {/* Formulário */}
                <div className="border-0 border-round h-full w-full flex flex-column align-items-center justify-content-center">

                    <div className='flex flex-column border-0 shadow-0 justify-content-center align-items-center border-round-2xl bg-white w-20rem'>

                        <Toast ref={toast} />
                        <h2 className="flex flex-row justify-content-start align-items-center text-900 mb-4">
                            <img src="/logo.svg" className='' alt="Logo" style={{ width: '9%' }} />
                            <div className='ml-2 font-light'>Criar sua senha</div>
                        </h2>

                        {message && <div className='fadeinleft text-logo-main mb-3'>
                            <Message severity={messageSeverity} text={message} />
                        </div>}

                        <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-column gap-1 w-20rem border-0">
                            <Controller
                                name="email"
                                control={form.control}
                                rules={{ required: 'email' }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.email })}>
                                        </label>
                                        <InputText
                                            id={field.name}
                                            {...field}
                                            placeholder='E-mail'
                                            inputMode="email"
                                            className={classNames("flex-1 border-2 border-round-2xl border-logo-main outline-none bg-transparent appearance-none text-gray-700 w-20rem px-3 py-2", { 'p-invalid': fieldState.error })}
                                            autoComplete="on"
                                        />
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />
                            <Controller
                                name="password"
                                control={form.control}
                                rules={{ required: 'A senha é obrigatória' }}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.password })}></label>
                                        <Password
                                            inputId={field.name}
                                            {...field}
                                            placeholder='Senha'
                                            inputClassName="flex-1 border-2 border-round-2xl border-logo-main outline-none bg-transparent appearance-none text-gray-700 w-20rem px-3 py-2"
                                            className={classNames("", { 'p-invalid': fieldState.error })}
                                            feedback={true}
                                            toggleMask={true}
                                            promptLabel="Informe sua senha"
                                            weakLabel="Tá indo bem..."
                                            mediumLabel="Médio"
                                            strongLabel="Essa é boa!"
                                            autoComplete="on"
                                            pt={{ showIcon: { className: 'mr-2' }, hideIcon: { className: 'mr-2' } }}
                                        />
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />
                            <Controller
                                name="password_repeat"
                                control={form.control}
                                rules={{
                                    required: 'A senha é obrigatória'
                                }}
                                defaultValue=""
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className={classNames({ 'p-error': errors.password })}></label>
                                        <Password inputId={field.name} {...field} placeholder='Repita a senha'
                                            inputClassName="flex-1 border-2 border-round-2xl border-logo-main outline-none bg-transparent appearance-none text-gray-700 w-20rem px-3 py-2"
                                            className={classNames("", { 'p-invalid': fieldState.error })}
                                            feedback={false}
                                            toggleMask={true}
                                            autoComplete="off"
                                            pt={{ showIcon: { className: 'mr-2' }, hideIcon: { className: 'mr-2' } }}
                                        />
                                        {getFormErrorMessage(field.name)}
                                    </>
                                )}
                            />

                            {/* Botão */}
                            <Button id='btnCreateAccount' label="Criar" type="submit" icon={loading ? "pi pi-spin pi-cog" : ""}
                                className="w-full font-bold bg-logo-main border-logo-main line-height-4 text-white border-2 border-solid border-round-2xl"
                            />

                            {/* Links adicionais */}
                            <div className="text-right mt-4">
                                <Link id='login' to="/login" className="text-logo-main no-underline">Login</Link>
                            </div>

                        </form>

                    </div>

                </div>

            </div>

        </div >
    )
}
